<script setup lang="ts">
import { type PropType } from 'vue'
import { type MemorialPrivilegeDTO } from '@/composables/life/life'
import { useRouter } from 'vue-router'

const props = defineProps({
  serviceId: {
    type: String,
    required: true
  },
  canArticle: {
    type: Boolean,
    required: true
  },
  privilege: {
    type: Object as PropType<MemorialPrivilegeDTO | null>,
    default: () => null
  },
  canCreateObituary: {
    type: Boolean,
    default: true
  }
})

const router = useRouter()

function createArticle() {
  router.push('/createMArticle?serviceId=' + props.serviceId + '&isEdit=false')
}
</script>

<template>
  <div w-full mt-1>
    <div flex="~ col" w-full items-center border-1 border-second rounded-2 border-dashed border-theme-gray py-3>
      <i i-stash:article-plus-light mt-6 h-12 w-16 text-theme-gray md:h-16 md:w-16></i>
      <div mb-2 mt-2 px-8 py-2>
        <CreateArticleButton v-if="canArticle" :canCreateObituary="canCreateObituary" :privilege="privilege" />
      </div>
      <div v-if="!props.canArticle" w-full mb-2 mt-12 h-8 text-center text-second>{{ $t('m.article_empty') }}</div>
    </div>
    <ArticleGuide />
  </div>
</template>

<style scoped>
/* style */
</style>
